import React from 'react';
import { AuthContext } from '../contexts/AuthProvider';

export default function useAuth() {
  const value = React.useContext(AuthContext);

  return value;
}
